import { Component } from "react";

export interface ErrorBoundaryProps {
  children: any;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, any> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: any) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: any) {
    // You can also log the error to an error reporting service
    console.log(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div style={{ paddingLeft: "20px" }}>
          <h1>Something went wrong...</h1>
          <h2>Check your internet connection or contact your technician.</h2>
        </div>
      );
    }

    return this.props.children;
  }
}
